// extracted by mini-css-extract-plugin
export var content = "survey-session-header-element-module--content--XAiRy";
export var surveySessionHeaderElement = "survey-session-header-element-module--survey-session-header-element--mXNfK";
export var title = "survey-session-header-element-module--title--xE+Tx";